/*
*###############################################################################
*Module Name                   : suplierCategoryMaster.js                      #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  Minol Prageesha                              #
*Date                          : Thursday, September 16th 2021, 4:58:43 pm     #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/


import React, { useState, useEffect, useContext } from "react"
import MetaTags from "react-meta-tags"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"

import DPTopToolBar from "../../../framework/widgets/DPTopToolBar"
import { Text } from "../../../framework/validators/TextValidation"
import SuplierCategoryMasterContent from "./suplierCategoryMasterContent"
import DPInfoBox from "../../../framework/layout/DPInfoBox"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPIframeBox from "framework/components/DPIframeBox"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from "framework/widgets/DPPermission"
import * as XLSX from "xlsx";
import DPPrintOption from "framework/widgets/DPPrintOptions"

import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import { DeleteSupplierCategory, SaveSupplierCategory, SupplierCategorysetCodeFind } from "./suplierCategoryController"
const SuplierCategoryMaster = props => {

  let history = useHistory();
  const [strSupCategoryCode, SetCode] = useState("");
  const [strSupCategoryDesc, SetDescription] = useState("")
  const [IsActive, SetActive] = useState(true)
  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [show, setShow] = useState(false)
  const [AlertMsg, setAlertMsg] = useState('')
  const [AlertColor, setAlertColor] = useState('')
  const [disabled, setDisabled] = useState(false)
  const [disabledCode, setDisabledCode] = useState(false)
  const [saveBtnEnable, setSaveEnable] = useState(true)
  const [modal_Iframe, setmodal_Iframe] = useState(false)
  const [crEnable, setCrEnable] = useState(false)
  const [crBy, setCrBy] = useState("")
  const [mdBy, setMdBy] = useState("")
  const [crDate, setCrDate] = useState("")
  const [mdDate, setMdDate] = useState("")
  const [ErrorMsg, setErrorMsg] = useState('')
  const [addNew, setaddNew] = useState(true)
  const [deleteEnable, SetDeleteEnable] = useState(false)
  const [menuCode, SetMenuCode] = useState("")
  const [Reason, setReason] = useState("Created")
  const [editEnable, SetEditEnable] = useState(false)
  //Alert Parameter
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
  //*****Menu Rights Start*/
  const [menuAccess, SetMenuAccess] = useState(false)
  const [menuCreate, SetMenuCreate] = useState(false)
  const [menuDelete, SetMenuDelete] = useState(false)
  const [menuModify, SetMenuModify] = useState(false)
  const [menuPrint, SetMenuPrint] = useState(false)
  const [menuProcess, SetMenuProcess] = useState(false)
  const [menuName, SetMenuName] = useState("")
  const [parentName, SetParentName] = useState("")
  const [LocationCode, setLocationCode] = useState("")
  const [LogUserType, setLogUserType] = useState("")
  const [LogCompanyCode, setLogCompanyCode] = useState("")
  //*****Menu Rights End */

  /**********Loading Alert */
  const [loadingAlert, SetLoadingAlert] = useState(false)
  const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
  /**********End Loading Alert */

  //autocode generation related newly added code
  const [codeButton, setCodeButton] = useState(true)
  const [searchdisabled, setSearchdisabled] = useState(false)
  const [nullCode, setNullCode] = useState(false)
  const [autoCode, setAutoCode] = useState(false)

  //User Permission related usestates
  const [permissionAlertShow, setPermissionAlertShow] = useState(false)
  const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
  const [permissionReasonShow, setPermissionReasonShow] = useState(false)
  const [permissionName, setPermissionName] = useState("")
  const [permissionPassword, setPermissionPassword] = useState("")
  const [permissionNameDisable, setPermissionNameDisable] = useState(false)
  const [printoptionShow, setprintoptionShow] = useState(false)
  const [valueUpload, setvalueUpload] = useState("")
  const [items, setItems] = useState([]);
  const [Excelitems, setExcelItems] = useState([]);
  const [helpUrl, setHelpUrl] = useState("")
  //import from contexts
  const {
    isHeadOffice, getMenuDetails, masterAuditLog, getSelectedMasterPermissions, fetchAutoCode, addtoFavourite
  } = useContext(Context);
  //import from contexts

  var time = process.env.REACT_APP_ALERTTIMEOUT

  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL

  //**Get File Details */
  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var menuDetail = await getMenuDetails(window.location.pathname + window.location.search)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
    var parentname = menuDetail?.parentName
    SetParentName(parentname)
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    setLocationCode(LocationCode)
    setLogUserType(LogUserType)
    setLogCompanyCode(CompanyCode)

    var responseData = await getSelectedMasterPermissions(LogUserType, menu)

    if (!responseData.strMenuAccessRight) {
      history.push('/dashboard')
    }

    SetMenuAccess(responseData.strMenuAccessRight)
    SetMenuCreate(responseData.strMenuCreateRight)
    SetMenuDelete(responseData.strMenuDeleteRight)
    SetMenuModify(responseData.strMenuModifyRight)
    SetMenuPrint(responseData.strMenuPrintRight)
    SetMenuProcess(responseData.strMenuProcessRight)
    SetMenuName(responseData.strMenuName)
    SetMenuCode(responseData.strMenuTag)
    setPermissionReasonShow(responseData.strMenuReasonShow)
    setHelpUrl(responseData.strHelpUrl)
    var autoCodeRes = await fetchAutoCode(menu)

    if (autoCodeRes.nullCode == false) {
      setAutoCode(autoCodeRes.autoCode)
    } else {
      setNullCode(true)
      setAutoCode("")
    }

  }, [strSupCategoryCode])

  // AuditLog
  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu =
      menuDetail && menuDetail.menuTag
        ? menuDetail.menuTag
        : history.push("/dashboard")

    await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log
  }, [])



  const readExcel = (file) => {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);

      fileReader.onload = (e) => {
        const bufferArray = e.target.result;

        const wb = XLSX.read(bufferArray, { type: "buffer" });

        const wsname = wb.SheetNames[0];

        const ws = wb.Sheets[wsname];

        const data = XLSX.utils.sheet_to_json(ws);

        setExcelItems(data);
        resolve(data);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });

    promise.then((d) => {
      setItems(d);
    });
  };



  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  function tog_xlarge() {

    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }
  function tog_Iframe() {
    setmodal_Iframe(!modal_Iframe)
    removeBodyCss()
  }

  function stringToBool(value) {
    value = value.toString().toLowerCase();
    return value === "1" || value === "true"

  }

  const GetSelectRow = (e, row, isSelect, rowIndex) => {
    SetCode(row.SC_CODE);
    setCodeFind(row.SC_CODE)
    setDisabled(true)
    setDisabledCode(true)
    setSaveEnable(false)
    SetDeleteEnable(true)
    setmodal_xlarge(!modal_xlarge);
  }

  //Clear
  const ClearItem = () => {
    SetCode("")
    SetDescription("")
    setDisabled(false)
    setDisabledCode(false)
    setCrEnable(false)
    setErrorMsg("")
    SetDeleteEnable(false)
    SetDeleteEnable(false)
    setNullCode(false)
    setSearchdisabled(false)
    setReason("Created")
    SetEditEnable(false)
    setSaveEnable(true)
    setPermissionName("")
    setPermissionPassword("")
    setPermissionNameDisable(false)
    setExcelItems([])
    setTimeout(() => {
      setExcelItems([])
    }, 1)
  }

  //Toolbar Fucntions
  const handleNew = e => {
    //    e.preventDefault()
    ClearItem();
    setShow(false)
    setSaveEnable(true)
    setaddNew(true)
  }

  const handlesave = async (e) => {
    var ExcelItemsRows = [...Excelitems]
    if (Array.isArray(ExcelItemsRows) && ExcelItemsRows.length) {
      var saveList = []
      ExcelItemsRows.map(async (localState) => {
        if ((localState.Code != null) && (localState.Description != null) && (localState.Active != null) || !localState.Active) {
          saveList.push({
            SupCategoryCode: localState.Code,
            SupCategoryDesc: localState.Description,
            IsActive: stringToBool(localState.Active),
          })
        }
      })

      const suplierCategoryArray = {
        SupplierCategoryList: saveList,
        User: LogUserType,
        MenuCode: menuCode,
        LoggedCompany: LogCompanyCode,
        LoggedLocation: LocationCode,
        Reason: Reason,
        CreateBy: LogUserType,
      }

      //var response = await SaveSupplierCategoryListDetails(suplierCategoryArray);

      if (response.success) {
        displayAlertMessage('success', response.message)

        // var autoCodeRes = await fetchAutoCode(menuCode)
        // setExcelItems([]);
        // setvalueUpload("");

        // if (autoCodeRes.nullCode == false) {
        //   setAutoCode(autoCodeRes.autoCode)

        // } else {
        //   setNullCode(true)
        //   setAutoCode("")
        // }

      } else {
        displayAlertMessage('danger', response.message)
      }

    } else {

      //set autogenerate code to as CODE just for display purpuse
      if (addNew == true && nullCode == false) {
        SetCode(autoCode)
      }

      if (strSupCategoryCode == "" && nullCode == true) {
        displayAlertMessage('danger', "Please Enter Supplier Category Code !")
        return;
      }
      if (strSupCategoryDesc == "") {
        displayAlertMessage('danger', "Please Enter Supplier Category Description !")
        return;
      }
      var blActiveStat = IsActive == "1" ? true : false;
      const SuplierCategoty = {
        "strSupCategoryCode": addNew == true && nullCode == false ? autoCode : strSupCategoryCode,
        "strSupCategoryDesc": strSupCategoryDesc,
        "IsActive": blActiveStat,
        "strMenuCode": menuCode,
        "strLoggedCompany": LogCompanyCode,
        "strLoggedLocation": LocationCode,
        "strReason": Reason,
        "strCreateBy": LogUserType,
        "blAddNew": addNew
      }
      //loading alert show
      SetLoadingAlert(true)
      if (addNew == true) {
        SetLoadingAlerttitle("Saving...")
      } else {
        SetLoadingAlerttitle("Updating...")
      }

      const result = await SaveSupplierCategory(SuplierCategoty);

      SetLoadingAlert(false)

      if (result.success) {
        displayAlertMessage("success", result.data)
        ClearItem()
      } else {
        if (result.data == "Code Already Exsist!") {
          setCodeButton(false)
        }
        displayAlertMessage("danger", result.data)
      }

    }
  }
  // //***save/update end */

  const handleEdit = e => {
    setDisabled(false)
    setDisabledCode(true)
    setSaveEnable(true)
    setaddNew(false)
    SetDeleteEnable(true)
    SetEditEnable(false)
  }

  //*** Get and Set values when user search code */
  const setCodeFind = async (CodeFind) => {

    if (CodeFind == "") return

    SetLoadingAlert(true)
    SetLoadingAlerttitle("Fetching...")

    const result = await SupplierCategorysetCodeFind(CodeFind);

    SetLoadingAlert(false)

    if (result.success == true) {

      SetDescription(result.data.name),
        SetActive(result.data.status),
        setCrBy(result.data.createdBy),
        setCrDate(result.data.createdDate),
        setMdBy(result.data.modifiedBy),
        setMdDate(result.data.modifiedDate)
      setDisabled(true)
      setDisabledCode(true)
      setSaveEnable(false)
      SetDeleteEnable(true)
      setCrEnable(true)
      setSearchdisabled(true)
      setReason("Updated")
      SetEditEnable(true)

    } else {
      if (nullCode == false) {
        displayAlertMessage('success', "Record Not Found !")
        setDisabledCode(true)
        SetCode("")
      }
    }
  }

  //End Toolbar Functions


  //********Delete button function */
  const handleDelete = async () => {

    const rowDelete = {
      "strMenuCode": menuCode,
      "strCode": strSupCategoryCode,
      "strLoggedCompany": LogCompanyCode,
      "strLoggedLocation": LocationCode,
      "strReason": Reason,
      "strCreateBy": LogUserType
    }

    //loading alert show
    SetLoadingAlert(true)
    SetLoadingAlerttitle("Deleting...")

    const result = await DeleteSupplierCategory(rowDelete);

    SetLoadingAlert(false)

    if (result.success) {
      displayAlertMessage("success", result.data)
      ClearItem()

    } else {

      displayAlertMessage("danger", result.data)

    }
  }

  //*********Delete button function end */
  // print Function
  async function handlePrint(option) {
    var option = option

    SetLoadingAlert(true)
    SetLoadingAlerttitle("Generating Report...")

    const ReportURL = window.Links.ReportURL
    await fetch(`${ReportURL}api/SupplierCategory/report/${LogUserType}/${option == "PDF" ? 1 : 0}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      }
    }).then(Response => Response.json())
      .then(responseData => {

        if (responseData.success == true) {
          if (option == "PDF") {
            {
              const msg = responseData.msg
              window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)
            }
          }
          if (option == "XCEL") {
            {
              const msg = responseData.msg
              window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.xls`)
            }
          }

        }
        SetLoadingAlert(false)
      }).catch(error => {
        console.log(error.message)
        SetLoadingAlert(false)
      })
  }

  //CODE AUTO GEN
  const AutoGenerateCode = async () => {
    await fetch(`${ApiURL}common/autocode/${menuCode}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      },
    }).then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {
          if (responseData.data.length > 0) {
            SetCode(responseData.data)
            setAutoCode(responseData.data)
          } else {
            setDisabledCode(false)
          }
        }
      })
  }


  //**Permission Check */
  const permission = (operation) => {
    const permissiondata = {
      strUsername: permissionName,
      strPassword: permissionPassword,
      strLocation: LocationCode,
      strMenuCode: menuCode
    }

    clearPermissionInputs()

    fetch(`${ApiURL}login/userpermission`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
        body: JSON.stringify(permissiondata)
      }
    ).then(Response => {
      if (Response.status == "200") {
        Response.json()
          .then(responseData => {

            let Access = (responseData.data.strMenuAccessRight)
            let Create = (responseData.data.strMenuCreateRight)
            let Delete = (responseData.data.strMenuDeleteRight)
            let Modify = (responseData.data.strMenuModifyRight)
            let Print = (responseData.data.strMenuPrintRight)
            let Process = (responseData.data.strMenuProcessRight)

            if (operation == "Save") {
              if (Create == true) {
                handlesave()
              } else if (Modify == true) {
                handlesave()
              } else {
                displayAlertMessage('danger', `This user don't have permisiion to ${addNew == true ? "save " : " update "} !`)
              }
            } else if (operation == "Delete") {
              if (Delete == true) {
                handleDelete()
              } else {
                displayAlertMessage('danger', "This user don't have permission to delete !")
              }
            } else if (operation == "Print") {
              if (Print == true) {
                setprintoptionShow(true)
              } else {
                displayAlertMessage('danger', "This user don't have permission to print !")
              }
            }
          }
          )

      } else if (Response.status == "400") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "Oops something went wrong !")
        clearPermissionInputs()

      } else if (Response.status == "403") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "You have not Permission to make changes !")
        clearPermissionInputs()

      } else if (Response.status == "404") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "Password or User Name is Invalid !")
        clearPermissionInputs()

      } else {
        ClearItem()
      }
    }).catch(error => {
      console.log(error.message)
    })
  }


  // Function for displaying Alert Messages.
  function displayAlertMessage(color, message) {
    setAlertColor(color)
    setAlertMsg(message)
    setShow(true)

    setTimeout(() => {
      setShow(false)
    }, time)
  }


  //handle permission alert
  function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
    setPermissionName(LogUserType)
    setReason(reason)
    setPermissionNameDisable(disable)
    setPermissionAlertShow(alertShow)
  }


  //Clear permission name & password
  function clearPermissionInputs() {
    setPermissionName("");
    setPermissionPassword("");
    setReason("");
  }


  //Handle Favourite Button
  const handleFavourite = async () => {
    var response = await addtoFavourite(menuCode, LogUserType);
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{menuName}</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs title={parentName} breadcrumbItem={menuName} />
          <DPAlert
            confirm_both={sweetAlertShow}
            title={menuName}
            description={AlertDescription}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            onConfirm={() => {
              setsweetAlertShow(false)
              if (AlertConfirmOption == 1) {

                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                  handlesave()
                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Created", true, true)
                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                  handlesave()
                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Updated", true, true)
                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }

              } else if (AlertConfirmOption == 2) {
                handleEdit()
              } else if (AlertConfirmOption == 3) {
                history.push('/dashboard')
              } else if (AlertConfirmOption == 4) {
                handleNew()
              } else if (AlertConfirmOption == 5) {

                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                  handleDelete()
                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Deleted", true, true)
                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }
              } else if (AlertConfirmOption == 6) {
                if (menuPrint == true && permissionReasonShow == false) {
                  setprintoptionShow(true)
                } else if (menuPrint == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Printed", true, true)
                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }
              }

            }}
            onCancel={() => {
              setsweetAlertShow(false)
            }}
          />
          <DPPermission
            confirm_both={permissionAlertShow}
            title={menuName}
            description={permissionAlertTitle}
            showReason={permissionReasonShow}
            nameDisable={permissionNameDisable}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            AlName={permissionName}
            AlNameOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setPermissionName(val2)
            }}
            AlPassward={permissionPassword}
            AlPasswardOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setPermissionPassword(val2)
            }}
            AlReason={Reason}
            AlReasonOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setReason(val2)
            }}
            onConfirm={() => {
              setPermissionAlertShow(false)
              if (AlertConfirmOption == 1) {
                permission("Save")
              } else if (AlertConfirmOption == 5) {
                permission("Delete")
              } else if (AlertConfirmOption == 6) {
                permission("Print")
              }
            }}
            onCancel={() => {
              setPermissionAlertShow(false)
              clearPermissionInputs()
            }}
          />
          <DPPrintOption
            confirm_both={printoptionShow}
            title={menuName}
            showCancel={true}
            cancelColor={"danger"}
            onConfirmpdf={() => {
              handlePrint("PDF")
              setprintoptionShow(false)
            }}
            onConfirmxcel={() => {
              handlePrint("XCEL")
              setprintoptionShow(false)
            }}
            onCancel={() => {
              setprintoptionShow(false)
            }}
          />
          <DPLoadingAlert
            confirm_both={loadingAlert}
            title={loadingAlertTitle}
          />

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Row>
                    <DPTopToolBar
                      //Help Button
                      helpEnable={helpUrl != "" ? true : false}
                      helpClick={() => {
                        window.open(helpUrl)
                      }}
                      //Favorite Button
                      favoriteEnable={true}
                      favoriteClick={handleFavourite}
                      //New Button
                      newEnable={true}
                      newClick={() => {
                        setAlertDescription("Do you wish to refresh the screen ?");
                        setAlertConfirmOption(4)
                        setsweetAlertShow(true)
                      }}
                      //Save Button
                      saveEnable={saveBtnEnable && isHeadOffice}
                      saveClick={() => {
                        setAlertDescription("Do you wish to save ?");
                        setAlertConfirmOption(1)
                        setsweetAlertShow(true)
                      }}
                      //ProcessButton
                      processEnable={false}
                      processClick={() => {
                        alert("Process")
                      }}
                      //Edit Button
                      editEnable={editEnable && isHeadOffice}
                      editClick={() => {
                        setAlertDescription("Do you wish to edit ?");
                        setAlertConfirmOption(2)
                        setsweetAlertShow(true)
                      }}
                      //Print Button
                      printEnable={true}
                      printClick={() => {
                        setReason("Printed")
                        setAlertDescription("Do you wish to print ?");
                        setAlertConfirmOption(6)
                        setsweetAlertShow(true)
                      }}
                      //Delete Button
                      deleteEnable={deleteEnable}
                      deleteClick={() => {
                        setReason("Deleted")
                        setAlertDescription("Do you wish to delete ?");
                        setAlertConfirmOption(5)
                        setsweetAlertShow(true)
                      }}
                      //Exit Button
                      exitEnable={true}
                      exitClick={() => {
                        setAlertDescription("Do you wish to exit ?");
                        setAlertConfirmOption(3)
                        setsweetAlertShow(true)
                      }}
                    />
                    <SuplierCategoryMasterContent
                      findCode={e => {

                        setCodeFind(e.target.value)
                      }}
                      GetSelectRow={GetSelectRow}
                      CodeValue={strSupCategoryCode}
                      CodeonChange={e => {
                        let val1 = Text(e.target, 5, true, false, "upper", false);
                        SetCode(val1)
                      }}
                      DescValue={strSupCategoryDesc}
                      DesconChange={e => {
                        let val2 = Text(e.target, 50, true, true, "any", true);
                        SetDescription(val2)
                      }}
                      ActiveSw={IsActive}
                      SwonChange={() => {
                        SetActive(!IsActive)
                      }}
                      modelTrigger={tog_xlarge}
                      modelOpen={modal_xlarge}
                      show={show}
                      disabled={disabled}
                      disabledCode={disabledCode}
                      AlertColor={AlertColor}
                      AlertMsg={AlertMsg}
                      ErrorMsg={ErrorMsg}
                      menuName={menuName}
                      onButtonClick={e => {
                        AutoGenerateCode()
                        setCodeButton(true)
                      }}
                      btnDisable={codeButton}
                      SearchDisable={searchdisabled}
                      showFileUpload={(e) => {
                        const file = e.target.files[0];
                        readExcel(file);
                        setvalueUpload(e.target.value)
                      }}
                      valueUpload={valueUpload}
                      menuCode={menuCode}
                      autoCode={autoCode}
                    />
                  </Row>
                  <Row>
                    {crEnable ? (
                      <DPInfoBox
                        createdBy={crBy}
                        createdOn={crDate != '1900-01-01 00:00:00' ? (crDate) ? crDate.replace('T', ' ') : "" : ''}
                        modifiedBy={mdBy}
                        modifiedOn={mdDate != '1900-01-01 00:00:00' ? (mdDate) ? mdDate.replace('T', ' ') : "" : ''}
                      />
                    ) : null}
                  </Row>
                  <DPIframeBox
                    mainTitle="Area Print"
                    isOpen={modal_Iframe}
                    toggle={tog_Iframe}
                    src={`${window.Links.ApiURL}SupplierCategory/report`}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
export default SuplierCategoryMaster
